import type { CompanySection } from '../overview/sections-pane/sections-pane.state';

export const getSectionClassProp = (section: CompanySection) => ({
  className: 'section-' + section,
});
